<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col class="animated fadeIn" cols="12">
        <c-paginate table-uri="paginate/table/vendedores" caption="Tabla de vendedores" :fields="fields" avatar-key-name="logo" new-item-name="Nuevo vendedor" edit-name="Detalle de vendedor"></c-paginate>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import axios from 'axios'
  import _ from 'lodash'

  export default {
    name: 'PedidosIndex',
    data: () => {
      return {
        fields: [
          {
            key: 'imagenes_id_logo',
            label: 'Logo'
          },
          {
            key: 'nombre',
            label: 'Vendedor'
          },
          {
            key: 'descripcion',
            label: 'Descripción'
          },
          {
            key: 'estatus',
            label: 'Estatus'
          },
          {
            key: '_',
            label: ''
          }
        ]
      }
    }
  }

</script>
